/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Footer_Link_SearchInputs */

const en_directory_footer_link_search = /** @type {(inputs: Directory_Footer_Link_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search`)
};

const zh_directory_footer_link_search = /** @type {(inputs: Directory_Footer_Link_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜索`)
};

/**
* | output |
* | --- |
* | "Search" |
*
* @param {Directory_Footer_Link_SearchInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_footer_link_search = /** @type {((inputs?: Directory_Footer_Link_SearchInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Footer_Link_SearchInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_footer_link_search(inputs)
	return zh_directory_footer_link_search(inputs)
});
export { directory_footer_link_search as "directory.footer.link_search" }